'use es6';

import SeamlessImmutable from 'seamless-immutable';
import { LOCATION_CHANGE } from 'DesignData/reducers/Routing';
import { FINDER_FOLDER_CREATE, FINDER_FOLDER_DELETE, FINDER_FOLDER_DUPLICATE, FINDER_THEMES_CREATE_REQUEST, FINDER_THEMES_CREATE_RECEIVE, FINDER_THEMES_CREATE_ERROR, FINDER_THEMES_CREATE_CHILD_REQUEST, FINDER_THEMES_CREATE_CHILD_RECEIVE, FINDER_THEMES_CREATE_CHILD_ERROR, FINDER_THEMES_CREATE_CHILD_RESET, FINDER_THEMES_SET_ACTIVE_THEME_FOLDER_ID, FINDER_THEMES_DUPLICATE_REQUEST, FINDER_THEMES_DUPLICATE_RECEIVE, FINDER_THEMES_DUPLICATE_ERROR, FINDER_THEMES_FETCH_CHILD_THEMES, FINDER_THEMES_CHILD_ADD_FILE_RECEIVE, FINDER_THEMES_CHILD_ADD_FILE_REQUEST, FINDER_THEMES_CHILD_ADD_FILE_ERROR, FINDER_ASSETS_CHILD_ADD_FILE_RESET, FINDER_FETCH_THEMES } from 'DesignData/actions/ActionTypes';
import { isThemeRootFolder, getThemeFolderIdFromUrlSearchString } from 'DesignData/lib/themes/themes';
import { tryParseInt } from 'DesignData/lib/text';
let isInitialRoutingChange = true;
export default function Themes(state = SeamlessImmutable({
  activeThemeFolderId: null,
  themeCreationInProgress: false,
  themes: []
}), action) {
  switch (action.type) {
    case LOCATION_CHANGE:
      {
        if (!isInitialRoutingChange) {
          // Only set `activeThemeFolderId` from query param on app load (initial routing)
          isInitialRoutingChange = false;
          return state;
        }

        const {
          payload
        } = action;
        const id = payload && payload.search && getThemeFolderIdFromUrlSearchString(payload.search);
        if (!id) return state;
        const parsed = tryParseInt(id);

        if (parsed && parsed !== state.activeThemeFolderId) {
          return SeamlessImmutable.set(state, 'activeThemeFolderId', parsed);
        }

        return state;
      }

    case FINDER_THEMES_SET_ACTIVE_THEME_FOLDER_ID:
      {
        const id = action.folderId || null;
        return SeamlessImmutable.set(state, 'activeThemeFolderId', id);
      }

    case FINDER_THEMES_CREATE_RECEIVE:
    case FINDER_THEMES_DUPLICATE_RECEIVE:
      {
        return SeamlessImmutable.merge(state, {
          themeCreationInProgress: false,
          activeThemeFolderId: action.theme.folderId
        });
      }

    case FINDER_FOLDER_DELETE:
      {
        // Deactivate a theme folder if it is deleted
        const {
          folderId
        } = action;

        if (folderId && state.activeThemeFolderId === folderId) {
          return SeamlessImmutable.set(state, 'activeThemeFolderId', null);
        }

        return state;
      }

    case FINDER_THEMES_CREATE_REQUEST:
    case FINDER_THEMES_DUPLICATE_REQUEST:
      {
        return SeamlessImmutable.set(state, 'themeCreationInProgress', true);
      }

    case FINDER_THEMES_CREATE_ERROR:
    case FINDER_THEMES_DUPLICATE_ERROR:
      {
        return SeamlessImmutable.set(state, 'themeCreationInProgress', false);
      }

    case FINDER_THEMES_CREATE_CHILD_REQUEST:
    case FINDER_THEMES_CREATE_CHILD_RECEIVE:
      {
        const {
          status,
          theme
        } = action;
        const folderId = theme && theme.folderId;
        return SeamlessImmutable.merge(state, {
          childThemeCreationStatus: status,
          childThemeCreationError: null,
          activeThemeFolderId: folderId
        }, {
          deep: true
        });
      }

    case FINDER_THEMES_CREATE_CHILD_ERROR:
      {
        const {
          error,
          status
        } = action;
        return SeamlessImmutable.merge(state, {
          childThemeCreationStatus: status,
          childThemeCreationError: error
        }, {
          deep: true
        });
      }
    // Open theme view when a theme folder is created/cloned

    case FINDER_FOLDER_CREATE:
    case FINDER_FOLDER_DUPLICATE:
      {
        const {
          folder
        } = action;

        if (isThemeRootFolder(folder) && folder.id) {
          return SeamlessImmutable.set(state, 'activeThemeFolderId', folder.id);
        }

        return state;
      }

    case FINDER_THEMES_FETCH_CHILD_THEMES:
      {
        const {
          childThemes,
          isFetchingChildThemes
        } = action;
        return SeamlessImmutable.merge(state, {
          childThemes,
          isFetchingChildThemes
        }, {
          deep: true
        });
      }

    case FINDER_FETCH_THEMES:
      {
        return SeamlessImmutable.set(state, 'themes', action.themes);
      }

    case FINDER_THEMES_CHILD_ADD_FILE_REQUEST:
    case FINDER_THEMES_CHILD_ADD_FILE_RECEIVE:
      {
        const {
          status
        } = action;
        return SeamlessImmutable.merge(state, {
          parentThemeFileStatus: status,
          parentThemeFileError: null
        }, {
          deep: true
        });
      }

    case FINDER_THEMES_CHILD_ADD_FILE_ERROR:
      {
        const {
          error,
          status
        } = action;
        return SeamlessImmutable.merge(state, {
          parentThemeFileStatus: status,
          parentThemeFileError: error
        }, {
          deep: true
        });
      }

    case FINDER_THEMES_CREATE_CHILD_RESET:
      {
        return SeamlessImmutable.merge(state, {
          childThemeCreationStatus: null,
          childThemeCreationError: null
        });
      }

    case FINDER_ASSETS_CHILD_ADD_FILE_RESET:
      {
        return SeamlessImmutable.merge(state, {
          childThemes: [],
          isFetchingChildThemes: false,
          parentThemeId: null,
          parentThemeFileStatus: null,
          parentThemeFileError: null
        });
      }

    default:
      return state;
  }
}